import React, { useContext } from 'react';
import { AppContext, GameBoardContext } from '../../../context/createContext';
import { sendAudio } from '../../../settings/useSettings';
import AudioComponent from './AudioComponent';

const SettingsAudio = () => {
	const {
		audio: { music, sound, isMusicOff, isSoundOff },
		appFuncs: { setMusic, setSound, setisMusicOff, setisSoundOff }
		// settings,
	} = useContext(AppContext);

	const { stakes } = useContext(GameBoardContext);

	return (
		<>
			<AudioComponent
				type={'music'}
				title={'common.menu.music'}
				setVolume={setMusic}
				volume={music}
				mute={isMusicOff}
				setMute={setisMusicOff}
				setMusicHandler={() =>
					sendAudio({ music, sound, isMusicOff, isSoundOff }, stakes)
				}
			/>
			<AudioComponent
				type={'sound'}
				title={'common.menu.sound'}
				setVolume={setSound}
				volume={sound}
				mute={isSoundOff}
				setMute={setisSoundOff}
				setMusicHandler={() =>
					sendAudio({ music, sound, isMusicOff, isSoundOff }, stakes)
				}
			/>
		</>
	);
};

export default React.memo(SettingsAudio);
